export const jobPostingPlaceholderLink = 'jobs.com/company/position'

export const urlRegex =
  /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.){1,}[a-zA-Z0-9-]+(\/[^#\s]*)?(#.*)?$/

export const hostURL = /^(https?:\/\/)?(www\.)?([^/]+).*/

export const DEBOUNCE_DELAY = 1000
